import { useEffect } from "react";

// Each page in the original static site had its own <title> and
// <meta name="description">. In the SPA we set them per route so shared
// links and browser history stay meaningful.
export function usePageMeta(title: string, description?: string) {
  useEffect(() => {
    document.title = title;
    if (description !== undefined) {
      let tag = document.head.querySelector<HTMLMetaElement>('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
  }, [title, description]);
}
